import { createFileRoute } from '@tanstack/react-router';
import { groupQuery, openGroupsQuery } from '@/features/duplicates/api';
import { DuplicateGroupPage } from '@/features/duplicates/pages/DuplicateGroupPage';
import { duplicatesSearchSchema } from '@/features/duplicates/search';
import { sourcesQuery } from '@/features/sources/api';

// Carries the list's page, so the group knows its neighbours and the way back.
export const Route = createFileRoute('/_authed/ops/duplicates/$groupId')({
  staticData: { help: 'duplicate-group' },
  validateSearch: duplicatesSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, params, deps }) => {
    void queryClient.prefetchQuery(openGroupsQuery(deps));
    void queryClient.prefetchQuery(sourcesQuery());
    void queryClient.prefetchQuery(groupQuery(params.groupId));
  },
  component: DuplicateGroupPage,
});
